import {MenuItem, Stack} from "@mui/material";
import Typography from "@mui/material/Typography";
import ErrorHandlingForm from "../../../../components/formValidation/ErrorHandlingForm";
import {useState} from "react";
import {validateRequired} from "../../../../components/formValidation/validators";
import CustomTextField from "../../../../components/formValidation/CustomTextField";
import CustomSelect from "../../../../components/formValidation/CustomSelect";
import CustomSwitch from "../../../../components/formValidation/CustomSwitch";
import CustomChipField from "../../../../components/formValidation/CustomChipField";

const QuestionData = ({reference, obj}) => {
    const [data, setData] = useState({
        question: obj?.question || '',
        answer_type: obj?.answer_type || '1',
        required: obj?.required,
        options: obj?.options || [],
    });

    const [errors, setErrors] = useState({
        question: false,
        answer_type: false,
        required: false,
        options: false,
    });

    const conditionallyRequired = (value, condition) => {
        if (condition) return {
            valid: value.length > 0,
            error: 'Legalább egy opciót meg kell adni',
        }
        return {
            valid: true,
            error: '',
        }
    }

    const validators = {
        question: [validateRequired],
        answer_type: [validateRequired],
        required: [],
        options: [value => conditionallyRequired(value, data?.answer_type === '5')],
    }

    return <ErrorHandlingForm data={data} setData={setData} errors={errors} setErrors={setErrors}
                              validators={validators} reference={reference}>
        <Stack spacing={1} marginTop={2} marginBottom={2}>
            <Typography variant='caption' color='primary.main'>Kérdés*</Typography>
            <CustomTextField
                data={data}
                setData={setData}
                errors={errors}
                setErrors={setErrors}
                validators={validators}
                name='question'
                variant='standard'
            />

            <Typography variant='caption' color='primary.main'>Válasz típusa*</Typography>
            <CustomSelect
                data={data}
                setData={setData}
                errors={errors}
                setErrors={setErrors}
                validators={validators}
                name='answer_type'
                variant='standard'
            >
                <MenuItem value='1'>Szabad szöveges válasz</MenuItem>
                <MenuItem value='2'>Szám válasz</MenuItem>
                <MenuItem value='3'>Igen/nem</MenuItem>
                <MenuItem value='4'>Dátum válasz</MenuItem>
                <MenuItem value='5'>Legördülő</MenuItem>
            </CustomSelect>

            {data?.answer_type === '5' && <Stack spacing={1}>
                <Typography variant='caption' color='primary.main'>Válasz opciók*</Typography>
                <CustomChipField
                    data={data}
                    setData={setData}
                    errors={errors}
                    setErrors={setErrors}
                    validators={validators}
                    name='options'
                    variant='standard'
                />
            </Stack>}

            <Typography variant='caption' color='primary.main'>kötelező kitölteni a klienseknek</Typography>
            <CustomSwitch
                data={data}
                setData={setData}
                errors={errors}
                setErrors={setErrors}
                validators={validators}
                name='required'
                labelOff='Nem kötelező'
                labelOn='Kötelező'
            />
        </Stack>

    </ErrorHandlingForm>

}

export default QuestionData